'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mediaFilter = require('./media-filter.html');

var _mediaFilter2 = _interopRequireDefault(_mediaFilter);

var _mediaFilter3 = require('./media-filter.controller');

var _mediaFilter4 = _interopRequireDefault(_mediaFilter3);

require('./media-filter.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mediaFilterComponent = {
  restrict: 'E',
  bindings: {
    applyFilters: '&'
  },
  template: _mediaFilter2.default,
  controller: _mediaFilter4.default,
  controllerAs: 'vm'
};

exports.default = mediaFilterComponent;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/media-filter/media-filter.component.js
 **/